import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Sign from "../../images/teach/svg/png/Sign.png";
import Create from "../../images/teach/svg/png/Create.png";
import Share from "../../images/teach/svg/png/Share.png";
import "./Details.css";
import { BiPaperPlane } from "react-icons/bi";
import { AiOutlineVideoCameraAdd } from "react-icons/ai";
import { IoChatbubblesOutline } from "react-icons/io5";

export default function Details() {
  return (
    <Container className="details-margin">
      <Row className="details-row">
        <Col lg={6} md={6} sm={12}>
          <div className="details-svg">
            <BiPaperPlane />
          </div>
          <h4> Plan your course</h4>
          <p>
            You start with your passion and knowledge. Then choose a topic and
            plan your lectures in Google Docs, Microsoft Excel, or your favorite
            notebook
          </p>
          <p>
            You get to teach the way you want — even create courses in multiple
            languages and inspire more students.
          </p>
          <p>How we help you</p>
          <p>
            Hub Educational Online offers free courses on how to build your own
            course, complete with worksheets and real-world examples. Plus, our
            instructor dashboard and curriculum pages help keep you on track.
          </p>
        </Col>
        <Col lg={6} md={6} sm={12}>
          <Image fluid src={Sign} />
        </Col>
      </Row>
      <Row className="details-row">
        <Col lg={6} md={6} sm={12}>
          <Image fluid src={Create} />
        </Col>
        <Col lg={6} md={6} sm={12}>
          <div className="details-svg">
            <AiOutlineVideoCameraAdd />
          </div>
          <h4> Record your video</h4>
          <p>Lights, camera, action</p>
          <p>
            Got a smartphone or a DSLR? Add a microphone and you’re ready to
            film your first course from your home or wherever you happen to be.
          </p>
          <p>
            Camera shy? No Worries. Use screencasting software, like Camtasia,
            to screencast demos.
          </p>
          <p>How we help you</p>
          <p>
            Our support team is available to help and offers free review of your
            videos. And our online instructor community is here to offer advice
            and inspiration.
          </p>
        </Col>
      </Row>
      <Row className="details-row">
        <Col lg={6} md={6} sm={12}>
          <div className="details-svg">
            <IoChatbubblesOutline />
          </div>
          <h4> Build your community</h4>
          <p>Reach out</p>
          <p>
            Create quizzes, exercises, and assignments to build interactivity.
            Write welcome messages for your students and answer their questions.
            Because Hub Educational Online students don’t just watch, they do.
          </p>
          <p>How we help you</p>
          <p>
            We provide all the tools for messaging, Q&As, course announcements,
            and quizzes, all in one one place.
          </p>
        </Col>
        <Col lg={6} md={6} sm={12}>
          <Image fluid src={Share} />
        </Col>
      </Row>
    </Container>
  );
}
